
import { Component, Vue } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import LoginForm from '_c/login-form'
import { login, CheckArea, PhoneLogin } from '@/api/admin/user'
import md5 from 'js-md5'
import { SetToken, DecryptedDeleLocal } from '@/libs/util'
const userModule = namespace('user')

@Component({
    components: {
        LoginForm
    }
})
export default class Login extends Vue {
    // import action with namespace
    // @userModule.Action handleLogin;
    // @userModule.Action getUserInfo;
    // @userModule.Action GetData;
    phone_Code = {
        show: false,
        from: { code: '' },
        rules: {
            code: [
                {
                    required: true,
                    trigger: 'blur',
                    message: '请输入有效的手机验证码'
                }
            ]
        },
        params: {},
        numTxt: '重新发送',
        num: 60,
        loading: false
    }

    localMsg = {
        country: '',
        ip: '',
        city: ''
    }
    paramLogin = {}
    @Getter
    menuList
    handleSubmit({ userName, password, code }: { userName: string; password: string; code: String }) {
        this.paramLogin = {
            username: userName,
            password: md5(password),
            code: code
        }
        this.phone_Code.params = this.paramLogin
        login(this.paramLogin).then((res: any) => {
            let data = res._param
            if (!data.token) {
                this.$Message.success('验证码已发送，请注意查收')
                this.phone_Code.from = {
                    ...data,
                    code: ''
                }
                this.timerF()
                this.phone_Code.show = true
                return false
            }
            SetToken({
                uid: data.uid,
                role_name: data.role_name,
                token: data.token,
                type: data.type,
                role_id: data.role_id,
                status: data.status,
                username: data.username,
                nickname: data.nickname,
                tagNavList: []
            })
            this.$router.push({
                name: this.$config.homeName
            })
        })
    }
    //手机验证码登录
    private phonehandleSubmit() {
        ;(this.$refs.phone_Code as any).validate((valid: boolean) => {
            if (valid) {
                let params = {
                    ...this.phone_Code.from,
                    code: this.phone_Code.from.code
                }
                delete params['status']
                delete params['token']
                PhoneLogin(params)
                    .then((res) => {
                        let data = res['_param']
                        this.phone_Code.loading = false
                        SetToken({
                            uid: data.uid,
                            role_name: data.role_name,
                            token: data.token,
                            type: data.type,
                            role_id: data.role_id,
                            status: data.status,
                            nickname: data.nickname,
                            tagNavList: []
                        })
                        this.$router.push({
                            name: this.$config.homeName
                        })
                    })
                    .catch((err) => {
                        this.phone_Code.loading = false
                    })
            } else {
                return false
            }
        })
    }
    //重新获取
    phoncode() {
        login(this.paramLogin).then((res: any) => {
            let data = res._param
            if (!data.token) {
                this.$Message.success('验证码已发送，请注意查收')
                this.phone_Code.from = {
                    ...data,
                    code: ''
                }
                this.timerF()
                return false
            }
        })
    }
    timerF() {
        // let num = 5
        let timer = setInterval(() => {
            this.phone_Code.num--
            if (this.phone_Code.num < 0) {
                clearInterval(timer)
                this.phone_Code.numTxt = '重新发送'
                this.phone_Code.num = 60
            } else {
                this.phone_Code.numTxt = this.phone_Code.num + 's'
            }
        }, 1000)
    }
    closePhonecode() {
        ;(this.$refs.phone_Code as any).resetFields()
        this.phone_Code.show = false
    }
    mounted() {}
    created() {
        CheckArea({}).then((res) => {
            this.localMsg = res['_param']
        })
    }
}
